import React from 'react';
import BarLoader from './BarLoader';

export default function Loading() {
  return (
    <div className='w-dvw h-dvh bg-background-img bg-cover bg-repeat flex justify-center items-center'>
      <span className='text-[50px] sm:text-[90px] me-5'>Loading</span>
      <BarLoader className="!h-12 !w-2 sm:!h-20 sm:!w-4" />
    </div>
  )
}
